import { useDeletePatientFactMutation } from '../../repository';

const useDeletePatientFactUseCase = () => {
  const [deleteFact, { isLoading, isSuccess, data, error }] = useDeletePatientFactMutation();

  return { deleteFact, data, isLoading, isSuccess, error };
};

export default useDeletePatientFactUseCase;
